<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            LOG NOTE
        </v-alert>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="8">
                        <v-textarea
                            v-model="information.log_note"
                            label="Noted"
                            outlined
                            filled
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["information","condition"],
    data() {
        return {
            logtype: ["Log", "Follow Up"]
        }
    }
}
</script>
